import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LCM_AUTO_DISCOVERY_EMAILS_NEW_USER_SUPPRESSION = defineFcm(
	'lcm_auto_discovery_emails_new_user_suppression',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				new_user_if_created_within_days: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms_stack',
		description: 'Used to suppress auto AA emails to users who are new within a certain number of days.',
		import: false,
		template: {
			new_user_if_created_within_days: 30,
		},
	});
